import { z } from 'zod';
import { type TraceToolCall } from '../types';
import {
  extractReadFilePath,
  getReadFileName,
  isMarkdownFilePath,
} from './read-file-tool';

const WriteFileArgsSchema = z.object({
  content: z.string().optional(),
  filename: z.string().optional(),
});

export type TraceWriteFileEntry = {
  content: string;
  displayName?: string;
  filePath?: string;
  isMarkdown: boolean;
};

export function toTraceWriteFileEntry(
  toolCall: TraceToolCall,
): TraceWriteFileEntry {
  const parsed = WriteFileArgsSchema.safeParse(toolCall.args);
  const filename = parsed.success ? parsed.data.filename?.trim() : undefined;
  const filePath =
    extractReadFilePath(toolCall.args) ??
    (filename && filename.length > 0 ? filename : undefined);

  return {
    content: (parsed.success ? parsed.data.content : undefined)?.trim() ?? '',
    displayName: getReadFileName(filePath),
    filePath,
    isMarkdown: isMarkdownFilePath(filePath),
  };
}
